const ADMIN_CONSOLE_ENABLED =
  process.env.REACT_APP_ADMIN_CONSOLE_ENABLED !== "false";

const ADMIN_CONSOLE_ROLES = ["admin", "super_admin"];

const normalizeRole = (role) =>
  typeof role === "string" ? role.trim().toLowerCase() : "";

export const isAdminConsoleEnabled = () => ADMIN_CONSOLE_ENABLED;

export const canAccessAdminConsole = (user) => {
  if (!ADMIN_CONSOLE_ENABLED) {
    return false;
  }

  return ADMIN_CONSOLE_ROLES.includes(normalizeRole(user?.role));
};

export const isSuperAdmin = (user) => normalizeRole(user?.role) === "super_admin";